/*
  Leventh PDP v2 - one open row at a time
  ---------------------------------------------------------------------------
  Harry asked for every accordion on the page to hold a single open row.

  The HTML name attribute on a details element already does this natively, with
  no script at all, and every row carries one. This file is only the fallback
  for browsers that ignore the attribute: it listens for toggle and closes the
  other rows of the same group itself.

  It feature-detects first and does nothing where the browser handles it, so
  nothing runs twice and nothing fights the native behaviour.

  Loaded by both places that render a group: snippets/leventh-pdp2-accordion
  and sections/leventh-pdp-faq. The guard below keeps a second script tag from
  binding a second listener.

  No polling and no timers, per core 4.5.
*/
(function () {
  'use strict';

  if (window.leventhDetailsGroups) return;
  window.leventhDetailsGroups = true;

  // Browsers that implement exclusive accordions expose name on the element.
  if ('name' in document.createElement('details')) return;

  document.addEventListener(
    'toggle',
    function (event) {
      var target = event.target;
      if (!target || target.tagName !== 'DETAILS' || !target.open) return;

      var group = target.getAttribute('name');
      if (!group) return;

      var siblings = document.querySelectorAll('details[name="' + group + '"]');
      for (var i = 0; i < siblings.length; i += 1) {
        if (siblings[i] !== target) siblings[i].open = false;
      }
    },
    true // toggle does not bubble, so listen in the capture phase
  );
})();
